import { disableAnimationClass, scrollIntoView } from '@helpers/animate';
import { FocusRing, useFocusManager } from '@react-aria/focus';
import * as React from 'react';
import S from '../Accordion.styles';
import { useAccordion } from '../Context/Context';
const AccordionItem = (props) => {
    const accordion = useAccordion();
    const fm = useFocusManager();
    const [scrollToView, setScrollToView] = React.useState(false);
    const isActive = accordion.activeId === props.id;
    // Appending a unique identifier to ensure uniqueness
    const uniqueId = Math.random().toString(36).substr(2, 9);
    const headerId = `${props.id}-header-${uniqueId}`;
    const bodyId = `${props.id}-body`;
    React.useEffect(() => {
        const disabled = document.querySelector(disableAnimationClass);
        if (scrollToView) {
            const targetEl = document.getElementById(headerId);
            if (targetEl) {
                setTimeout(() => {
                    scrollIntoView(targetEl);
                }, disabled ? 15 : 350);
            }
            setScrollToView(false);
        }
    }, [scrollToView, headerId]);
    return (React.createElement(S.Item, { initial: isActive ? 'opened' : 'closed', animate: isActive ? 'opened' : 'closed', onKeyDown: (event) => {
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusNext();
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusPrevious();
                    break;
                case 'Home':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusFirst();
                    break;
                case 'End':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusLast();
                    break;
                default:
                    break;
            }
        }, "data-open": isActive },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.ItemHeader, { id: headerId, "aria-controls": bodyId, "aria-expanded": isActive, "aria-label": `Expand ${props.title}`, type: "button", onClick: (event) => {
                    event.preventDefault();
                    accordion.onClick(props.id);
                    setScrollToView(true);
                } },
                React.createElement(S.ItemTitle, null, props.title),
                React.createElement(S.ItemIcon, { "aria-hidden": "true" }))),
        React.createElement(S.ItemBody, { id: bodyId, "aria-labelledby": headerId, role: "region", tabIndex: -1, variants: {
                closed: {
                    height: 0,
                    transitionEnd: {
                        visibility: 'hidden',
                    },
                },
                opened: {
                    visibility: 'visible',
                    height: 'auto',
                },
            } },
            React.createElement(S.ItemBodyInner, null, props.children))));
};
export default AccordionItem;
